// extracted by mini-css-extract-plugin
export default {"Contact":"Contact_Contact__39776","Identite":"Contact_Identite__n7ie6","Message":"Contact_Message__6-CKh","Button":"Contact_Button__JKEzl"};